import { MAX_HEADING_SUMMARY_LENGTH } from "../globals";

export const truncateHeading = (str: string, n: number = MAX_HEADING_SUMMARY_LENGTH) => {
  return str.length > n ? str.substr(0, n - 1) + "..." : str;
};
